/* Keep the guide above sticky product galleries and outside their stacking contexts. */
if (!customElements.get('kk-size-guide-opener')) {
  customElements.define('kk-size-guide-opener', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => this.open());
    }

    open() {
      const modal = document.getElementById(this.dataset.modal);
      if (!modal || modal.hasAttribute('open')) return;
      this.modal = modal;
      this.placeholder = document.createComment('size-guide');
      modal.before(this.placeholder);
      document.body.append(modal);
      this.observer = new MutationObserver(() => {
        if (!modal.hasAttribute('open')) this.restore();
      });
      this.observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
      modal.open(this.button);
      modal.querySelector('.modal__window').scrollTop = 0;
    }

    restore() {
      this.observer?.disconnect();
      if (!this.modal) return;
      // The theme wraps tables on every opening; remove its wrapper before reuse.
      this.modal.querySelectorAll('.scrollable-table').forEach((wrapper) => {
        wrapper.replaceWith(...wrapper.childNodes);
      });
      if (this.placeholder?.parentNode) this.placeholder.replaceWith(this.modal);
      else this.modal.remove();
      this.modal = null;
    }

    disconnectedCallback() {
      if (this.modal?.hasAttribute('open')) this.modal.close();
      this.restore();
    }
  });
}
